import type { UmbMockTemplateModel } from '../data/mock-data-set.types.js';
import { UmbEntityMockDbBase } from './utils/entity/entity-base.js';
import { UmbMockEntityTreeManager } from './utils/entity/entity-tree.manager.js';
import { UmbMockEntityNamedItemManager } from './utils/entity/entity-named-item.manager.js';
import { UmbMockTemplateDetailManager } from './template-detail.manager.js';
import { UmbMockTemplateQueryManager } from './template-query.manager.js';
import type {
	NamedEntityTreeItemResponseModel,
	TemplateItemResponseModel,
} from '@umbraco-cms/backoffice/external/backend-api';

class UmbTemplateMockDB extends UmbEntityMockDbBase<UmbMockTemplateModel> {
	tree = new UmbMockEntityTreeManager<UmbMockTemplateModel>(this, treeItemMapper);
	item = new UmbMockEntityNamedItemManager<UmbMockTemplateModel>(this, itemMapper);
	detail = new UmbMockTemplateDetailManager(this);
	query = new UmbMockTemplateQueryManager();

	constructor(data: Array<UmbMockTemplateModel>) {
		super('template', data);
	}
}

const treeItemMapper = (model: UmbMockTemplateModel): NamedEntityTreeItemResponseModel => {
	return {
		name: model.name,
		hasChildren: model.hasChildren,
		id: model.id,
		parent: model.parent,
		flags: model.flags,
	};
};

const itemMapper = (item: UmbMockTemplateModel): TemplateItemResponseModel => {
	return {
		id: item.id,
		name: item.name,
		alias: item.alias,
		flags: item.flags,
	};
};

export const umbTemplateMockDb = new UmbTemplateMockDB([]);
